import styled from 'styled-components'

const ContentBoxWrapperOldUi = styled.div`
  min-height: 100px;
  width: 100%;
  ${p => p.theme.phone} {
    ${({ mobileStyles = {} }) => mobileStyles}
  }
  ${({ styles = {} }) => styles}
`

export default ContentBoxWrapperOldUi
